import { Text } from '@dixa/lib-shared-habla';

import { ConversationAutomationAuditLogEntry } from 'apis/auditLogs';

type RoutedThroughIntegrationProps = {
  node: ConversationAutomationAuditLogEntry<'AUTOMATION_EXTERNAL_INTEGRATION_NODE_VISITED'>;
};
export function RoutedThroughIntegration({
  node,
}: RoutedThroughIntegrationProps): JSX.Element {
  const { outcome } = node;

  if (outcome && outcome.type !== 'success') {
    const errorMessage =
      outcome.type === 'failed_to_construct'
        ? outcome.message
        : outcome.type === 'failed_connection'
          ? outcome.message
          : '';
    const errorCode =
      outcome.type === 'failed_call' ? outcome.http_status_code : '';
    const timeoutMessage = outcome.type === 'timed_out' ? 'Timeout' : '';
    const errorText =
      errorMessage || errorCode || timeoutMessage || 'An error occurred';
    return (
      <Text.Paragraph>
        HTTP(S) request · Failed with error: {errorText}
      </Text.Paragraph>
    );
  }

  if (outcome && outcome.type === 'success') {
    return (
      <Text.Paragraph>
        HTTP(S) request · Successfully called endpoint
      </Text.Paragraph>
    );
  }

  return <Text.Paragraph>HTTP(S) request · Endpoint called</Text.Paragraph>;
}
